import React from 'react';
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';

const RelatedWorkItemSkeleton = () => (
	<Inline xcss={relatedWorkWrapperStyles}>
		<Stack xcss={relatedWorkLeftWrapperStyles}>
			<Skeleton width="24px" height="24px" isShimmering />
		</Stack>
		<Stack xcss={relatedWorkRightWrapperStyles}>
			<Skeleton width="350px" height="24px" isShimmering />
			<Skeleton width="220px" height="18px" isShimmering />
		</Stack>
	</Inline>
);

export const RelatedWorkLoadingSkeleton = () => (
	<Box>
		<Stack xcss={headerSkeletonStyles}>
			<Skeleton width="220px" height="24px" isShimmering />
		</Stack>
		<Inline xcss={categoryFilterRowStlyes}>
			<Skeleton isShimmering borderRadius={14} width="52px" height="26px" />
			<Skeleton isShimmering borderRadius={14} width="85px" height="26px" />
			<Skeleton isShimmering borderRadius={14} width="125px" height="26px" />
			<Skeleton isShimmering borderRadius={14} width="110px" height="26px" />
			<Skeleton isShimmering borderRadius={14} width="110" height="26px" />
			<Skeleton isShimmering borderRadius={14} width="70px" height="26px" />
		</Inline>
		<Stack>
			<RelatedWorkItemSkeleton />
		</Stack>
	</Box>
);

const headerSkeletonStyles = xcss({
	marginTop: 'space.500',
	marginBottom: 'space.250',
});

const categoryFilterRowStlyes = xcss({
	gap: 'space.100',
	marginBottom: 'space.150',
});

const relatedWorkWrapperStyles = xcss({
	height: 'space.800',
});

const relatedWorkRightWrapperStyles = xcss({
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	gap: 'space.150',
});

const relatedWorkLeftWrapperStyles = xcss({
	width: '64px',
	height: '64px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});
